<template>
  <div>
    <v-container>
      <v-layout
          text-center>
        <v-flex>
          <h1 style="font-size: 39px; font-weight: normal" class="mb-4">Über uns</h1>

        </v-flex>

      </v-layout>

      <v-container>
        <v-row>
          <v-col md="3"></v-col>
          <v-col cols="12" md="6">
            <v-card class="d-flex flex-column" color="#2e7d32" dark>
              <v-card-title>Unsere Kanzlei</v-card-title>
              <v-card-text>
                Unsere Kanzlei bietet als Legal Tech seinen Kunden eine große Zahl webbasierter Rechtsdienstleistungen an. Unsere Kooperationsanwälte führen auf unterschiedlichen Medien und Wegen mehr als 50.000 Rechtsberatungen pro Jahr durch.
              </v-card-text>
              <v-card-text>
                Darüber hinaus vertreten wir Mandanten in strafrechtlichen Angelegenheiten (allgemeines, Wirtschafts- und Verkehrsstrafrecht) sowie bei arbeits-, medizin-, vertrags- und familienrechtlichen Auseinandersetzungen.
              </v-card-text>
              <v-card-text>
                Melden Sie sich gerne mit Ihrem Anliegen bei uns – wir rufen schnellstmöglich zurück.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </v-container>
    <v-sheet color="#2e7d32">
      <v-container grid-list-md >
        <v-layout align-center justify-center row fill-height>
          <v-flex xs12 sm6 md6 lg4 v-bind:key="bullet.id" v-for="bullet in bullets[0]">
            <v-card height="180">
              <v-card-title>{{ bullet.Title }}</v-card-title>
              <v-card-text text-center>{{ bullet.Description }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-sheet>


  </div>
</template>
<script>
    export default {
        data: () => ({
          text: "Unsere Kanzlei bietet als Legal Tech seinen b2b-Kunden eine große Zahl webbasierter Rechtsdienstleistungen an. Unsere Kooperationsanwälte führen auf unterschiedlichen Medien und Wegen mehr als 50.000 Rechtsberatungen pro Jahr durch.<br /> Darüber hinaus vertreten wir Mandanten in strafrechtlichen Angelegenheiten (allgemeines, Wirtschafts- und Verkehrsstrafrecht) sowie bei arbeits-, medizin-, vertrags- und familienrechtlichen Auseinandersetzungen.<br/>  Melden Sie sich gerne mit Ihrem Anliegen bei uns – wir rufen schnellstmöglich zurück. <br /> Ihre 24/7 Hotline: <a>06171 - </a>.  <br />Wenn Sie uns nicht direkt erreichen, erfolgt unser Rückruf spätestens am folgenden Werktag.",
            bullets: [{
                0: {Title: "Erreichbarkeit", Description: "Wir richten unsere Anwaltshotline nach Ihren zeitlichen Vorgaben ein.", picture: "Erreichbarkeit.jpg"},
                1: {Title: "Beratung", Description: "Unsere Dienstleistung für Ihre Zielerreichung: sehr gute Erreichbarkeit und eine hohe Ausberatungsquote am Telefon.", picture: "Beratung.jpg"},
                2: {Title: "Kunden", Description: "Namhafte, langjährige und zufriedene Kunden aus verschiedenen Wirtschaftszweigen (wie z.B. Rechtsschutzversicherer, Autohäuser, …)", picture: "Beratung.jpg"},
                3: {Title: "Erfahrung", Description: "Unsere Anwälte-/innen verfügen neben ihrer anwaltlichen Berufserfahrung über eine langjährige Hotlinepraxis.", picture: "Beratung.jpg"},
                4: {Title: "Rechtsgebiete", Description: "Wir decken alle gängigen Rechtsgebiete ab und bauen für Sie auch gerne Spezialgebiete auf.", picture: "Beratung.jpg"},
                5: {Title: "Kosten", Description: "Wir sind flexibel in unserem Gebührenmodell", picture: "Kosten.jpg"},
            }],
            Special: [{
                title: "Spezialisierung auf",
                bullets: {
                    0: "Arbeitsrecht",
                    1: "Steuerrecht",
                    2: "Ordnungswidrigkeiten",
                    3: "Medizinrecht",
                    4: "Immobilienrecht",
                    5: "Mietrecht",
                    6: "Reiserecht"
                }
            }]
        }),
    };
</script>

